import { Button } from '@jouzen/ecom-components/v3/Button';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import RichText from '@/app/components/RichText';
import SimpleTwoColumnModule from '@/app/components/SimpleTwoColumnModule';

const ConfirmSizeSection = () => {
  const t = useTranslations();

  return (
    <SimpleTwoColumnModule
      data-cy="confirm-size-section"
      heading={{ content: 'confirm_your_size' }}
    >
      <Typography className="text-lg">
        <RichText messageKey="sizing_gen4_confirm_size_content" />
      </Typography>
      <Button href="/my-account" size="large" variant="secondary-dark">
        {t('confirm_your_size')}
      </Button>
    </SimpleTwoColumnModule>
  );
};

export default ConfirmSizeSection;
